import { NgModule } from '@angular/core';
import { NgServiceWorker } from './comm';
var ServiceWorkerModule = (function () {
    function ServiceWorkerModule() {
    }
    return ServiceWorkerModule;
}());
export { ServiceWorkerModule };
ServiceWorkerModule.decorators = [
    { type: NgModule, args: [{
                providers: [NgServiceWorker],
            },] },
];
/** @nocollapse */
ServiceWorkerModule.ctorParameters = function () { return []; };
//# sourceMappingURL=module.js.map


// WEBPACK FOOTER //
// ./node_modules/@angular/service-worker/companion/module.js.pre-build-optimizer.js